import type { ColDef } from 'ag-grid-community';

export const InternalSalesForexColumnDefinitions: ColDef[] = [
  {
    field: 'name',
    type: 'string',
  },
  {
    field: 'currency1',
    type: 'currency',
  },
  {
    field: 'currency2',
    type: 'currency',
  },
  {
    field: 'marketPlace',
    type: 'string',
  },
  {
    field: 'masterDesk',
    type: 'string',
  },
  {
    field: 'defaultCutOff',
    type: 'string',
  },
  {
    field: 'cutOffs',
    type: 'stringArray',
  },
];

export const externalUserForexColumnDefinitions: ColDef[] = [
  {
    field: 'name',
    type: 'string',
  },
  {
    field: 'currency1',
    type: 'currency',
  },
  {
    field: 'currency2',
    type: 'currency',
  },
  {
    field: 'defaultCutOff',
    type: 'string',
  },
  {
    field: 'cutOffs',
    type: 'stringArray',
  },
];
